<template>
  <page-card>
    <template slot="header">
      <span>Personal Verification</span>
    </template>
    <div slot="body">
      <component ref="areaComp" :is="areaComp[area]" :area="area"/>
    </div>
  </page-card>
</template>

<script>
import CAPage from "@/views/authentication/IdentityKYC/components/CAPage.vue";
import CNPage from "@/views/authentication/IdentityKYC/components/CNPage.vue";
import USPage from "@/views/authentication/IdentityKYC/components/USPage.vue";
import HKPage from "@/views/authentication/IdentityKYC/components/HKPage.vue";
export default {
  components: {
    CAPage,
    CNPage,
    USPage,
    HKPage
  },
  props: {
    area: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      areaComp:{
        CA:"CAPage",
        US:"USPage",
        HK:"HKPage",
        CN:"CNPage",
      }
    };
  },
  methods: {
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs["areaComp"]
          .submit()
          .then(res => {
            console.log(res)
            resolve({ type: "end" });
          })
          .catch(e => {
            console.log(e)
            reject(e);
          });
      });
    }
  }
};
</script>
<style scoped lang="scss"></style>
